// extracted by mini-css-extract-plugin
export default {"button":"SpoilerButton_button__dE8W7","icon":"SpoilerButton_icon__-9eah"};